export class MemberCountWithCategoriesResult
{
    TotalMembers!: number;
    MembersMatchingCategories!: number;

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
    }
}
